<template>
  <div class="cooperative wrapW">
    <div class="titleD">
      <div class="titleDT">P</div>
      <div>
        <h4 class="titlex">artner</h4>
        <h2 class="title">合作伙伴</h2>
      </div>
    </div>
    <div class="xian"></div>
    <div class="Tdescribe">多方位、多角度提供商品，让您更快选到满意商品</div>
    <div class="choice">
      <div @mouseenter="is_nav=0" :class="{action:is_nav === 0}">合作企业</div>
      <div :class="{action:is_nav === 1}" @mouseenter="is_nav=1" >合作品牌</div>
    </div>
    <ul v-show="is_nav==0" class="logo clearfix" v-for="(i,index) in coCompany" :key="'i'+index" :style="{width:shu1*2.23 +'rem'}">
      <li v-for="(item,index) in i" :key="index">
        <img :src="item.img" :alt="item.name">
      </li>
    </ul>
    <ul  v-show="is_nav==1" class="logo clearfix" v-for="(i,index) in coBrand" :key="index" :style="{width:shu*2.23 +'rem'}">
      <li v-for="(item,index) in i" :key="index">
        <img :src="item.img" :alt="item.name">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'cooperative',
  data () {
    return {
      list: [],
      title: '',
      slaveTitle: '',
      slaveTitleX: '',
      introduce: '',
      shu: 0,
      shu1: 0,
      coCompany: [],
      coBrand: [],
      is_nav: 0
    }
  },
  mounted () {
    this.getCoCompany()
  },
  methods: {
    getCoCompany () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getCoCompany', {
      }).then(
        function (res) {
          res = res.data.data
          if (res.list.coBrand.length > 0) {
            let shu = Math.ceil(res.list.coBrand.length/4)
            that.shu = shu
            let num = 0
            let coBrand = []
            for (var i = 0; i< 5 ; i++) {
              num = i*shu
              coBrand[i] = res.list.coBrand.slice(num,shu+shu*i)
            }
            that.coBrand = coBrand
          }
          if (res.list.coCompany.length > 0) {
            let shu1 = Math.ceil(res.list.coCompany.length/4)
            that.shu1 = shu1
            let num1 = 0
            let coCompany = []
            for (var i = 0; i< 5 ; i++) {
              num1 = i*shu1
              coCompany[i] = res.list.coCompany.slice(num1,shu1+shu1*i)
            }
            that.coCompany = coCompany
          }
          that.title = res.introduce.title
          that.slaveTitle = res.introduce.slaveTitle.substr(1)
          that.slaveTitleX = res.introduce.slaveTitle.substr(0,1)
          that.introduce = res.introduce.desc
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.wrapW
  overflow hidden
.cooperative
  padding 1.2rem 0
.xian
  margin-bottom .22rem
.choice
  width 100%
  display flex
  justify-content center
  margin-top .5rem
  div
    padding .07rem .24rem
    background #C8C8C8
    border-radius .16rem
    font-size .18rem
    line-height .18rem
    color #fff
  div:first-child
    margin-right 1.76rem
  div.action
    background #D5A14E
.logo
  margin-top .52rem
  animation slideshow 20s linear infinite
  transform translate3d(0, 0, 0)
  @keyframes slideshow
    0%
      transform translateX(0%)
    50%
      transform translateX(-34%)
    100%
      transform translateX(0%)
  li
    width 1.74rem
    margin-right .49rem
    height .58rem
    float left
    img
      height 100%
  li:hover
    border 0px
    box-shadow 5px 10px 10px 0px rgba(150, 150, 150, 0.5)
.logo:nth-child(2n+0)
    margin-left 1rem
    animation slideshoww 20s linear infinite
    animation-delay 2s
    transform translate3d(0, 0, 0)
    @keyframes slideshoww
      10%
        transform translateX(0)
      50%
        transform translateX(-37%)
      100%
        transform translateX(0)
</style>



// WEBPACK FOOTER //
// src/pages/index/components/cooperative.vue